/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { axiosInstance } from "@app/axios/axiosIns";

export const addProject = createAsyncThunk(
  "project/add",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(`/admin/project`, data);
      return response;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const getAllProjects = createAsyncThunk(
  "project/all",
  async (params: any, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("/project", { params });
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateProjectFeaturedStatus = createAsyncThunk(
  "project/updateFeaturedStatus",
  async (
    {
      projectId,
      isFeatured,
      section,
    }: { projectId: string; isFeatured: boolean; section: any },
    { rejectWithValue }
  ) => {
    try {
      const response = await axiosInstance.patch(
        `/admin/project/${projectId}`,
        { is_featured: isFeatured, other_image: section }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateProjectSequenceBulk = createAsyncThunk(
  "project/updateSequenceBulk",
  async (projects: { id: string; sequence: number }[], { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "/admin/project/updateSequence",
        {
          project: projects,
        }
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const getProject = createAsyncThunk(
  "project/get",
  async (project_id: any, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/project/${project_id}`);
      return response?.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateProject = createAsyncThunk(
  "project/update",
  async ({ id, data }: { id: any; data: any }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.patch(`/admin/project/${id}`, data);
      return response;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const deleteProject = createAsyncThunk(
  "project/delete",
  async (project_id: any, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.delete(
        `/admin/project/${project_id}`
      );
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

interface ProjectState {
  isLoading: boolean;
  formLoader: boolean;
  project: any;
  allProjects: any[];
  error: any;
}

const initialState: ProjectState = {
  isLoading: false,
  formLoader: false,
  project: null,
  allProjects: [],
  error: null,
};

const projectSlice: any = createSlice({
  name: "project",
  initialState,
  reducers: { resetState: () => initialState },
  extraReducers: (builder) => {
    builder
      .addCase(addProject.pending, (state) => {
        state.formLoader = true;
      })
      .addCase(addProject.fulfilled, (state, action) => {
        state.formLoader = false;
        state.project = action.payload?.data?.data;
      })
      .addCase(addProject.rejected, (state, action) => {
        state.formLoader = false;
        state.error = action.error.message;
      })
      .addCase(getAllProjects.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllProjects.fulfilled, (state, action) => {
        state.isLoading = false;
        state.allProjects = action.payload?.data;
      })
      .addCase(getAllProjects.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })
      .addCase(getProject.pending, (state) => {
        state.isLoading = true;
        state.project = null;
      })
      .addCase(getProject.fulfilled, (state, action) => {
        state.isLoading = false;
        state.project = action.payload?.data;
      })
      .addCase(getProject.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })
      .addCase(updateProject.pending, (state) => {
        state.formLoader = true;
      })
      .addCase(updateProject.fulfilled, (state, action) => {
        state.formLoader = false;
        state.project = action.payload?.data?.data;
      })
      .addCase(updateProject.rejected, (state, action) => {
        state.formLoader = false;
        state.error = action.error.message;
      })
      .addCase(deleteProject.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteProject.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(deleteProject.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })
      .addCase(updateProjectSequenceBulk.pending, (state) => {
        state.formLoader = true;
      })
      .addCase(updateProjectSequenceBulk.fulfilled, (state) => {
        state.formLoader = false;
      })
      .addCase(updateProjectSequenceBulk.rejected, (state, action) => {
        state.formLoader = false;
        state.error = action.error.message;
      });
    // .addCase(updateProjectFeaturedStatus.pending, (state) => {
    //   state.formLoader = true;
    // })
    // .addCase(updateProjectFeaturedStatus.fulfilled, (state, action) => {
    //   if (!Array.isArray(state.allProjects)) return;

    //   state.allProjects = state.allProjects.map((project) =>
    //     project.project_project_id === action.meta.arg.projectId
    //       ? { ...project, project_is_featured: action.meta.arg.isFeatured }
    //       : project
    //   );
    // })
    // .addCase(updateProjectFeaturedStatus.rejected, (state, action) => {
    //   state.formLoader = false;
    //   state.error = action.error.message;
    // });
  },
});

export const { resetState } = projectSlice.actions;
export default projectSlice.reducer;
